import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { RemuneracaoMedica } from '@/types/core'
import { ModalHistoricoPontuacao, HistoricoPontuacao } from '@/types/interfaces/HistoricoPontuacao'
import { ModalHistoricoSituacao, Historico } from '@/types/_'
import { ModalHistoricoSenioridade, HistoricoSenioridade } from '@/types/interfaces/HistoricoSenioridade'
import { ModalHistoricoCadastroAluguel } from '@/types/interfaces/HistoricoCadastroAluguel'
import { ModalHistoricoGeracaoItens } from '@/types/interfaces/HistoricoGeracaoItens'
import { ModalHistoricoGeracaoRepasse } from '@/types/interfaces/HistoricoSituacao'

@Module({ namespaced: true, name: 'HistoricoSituacaoStore' })
export default class HistoricoSituacaoStore extends VuexModule {
  modalPontuacao: ModalHistoricoPontuacao = {
    historicoPontuacao: false,
  }

  modalSenioridade: ModalHistoricoSenioridade = {
    historicoSenioridade: false,
  }

  modal: ModalHistoricoSituacao = {
    historicoSituacao: false,
  }

  modalCadastroAluguel: ModalHistoricoCadastroAluguel = {
    historicoCadastroAluguel: false,
  }

  modalHistoricoGeracaoItens: ModalHistoricoGeracaoItens = {
    historicoGeracaoItens: false,
  }

  modalHistoricoGeracaoRepasse: ModalHistoricoGeracaoRepasse = {
    historicoGeracaoRepasse: false,
  }

  historicoSituacao: Historico[] = []
  historicoGeracaoRepasse: any[] = []
  historicoIntegracaoRepasse: any[] = []
  showHistoricoIntegracaoTab: boolean = false
  validacaoResultado: any[] = []
  historicoCadastroAluguel: any[] = []
  historicoGeracaoItens: any[] = []
  historicoPontuacao: any[] = []
  historicoSenioridade: any[] = []
  totalItems: number = 0
  idForLoadItems: string = ''
  pagina: number = 1
  qtdPorPagina: number = 50
  remuneracaoMedica: RemuneracaoMedica.IPrestadorRecebimento = new RemuneracaoMedica.PrestadorRecebimento()

  @Action
  async getHistoricoSituacao(prestadorRecebimentoId: string) {
    const request = await this.remuneracaoMedica.getHistoricoSituacao(prestadorRecebimentoId)
    if (request.success) {
      this.context.commit('setHistoricoSituacao', request.data)
      this.context.commit('setShowModalHistoricoSituacao', true)
    }
    return request
  }

  @Action
  async getHistoricoGeracaoRepasse(prestadorRecebimentoId: string) {
    const request = await this.remuneracaoMedica.getHistoricoGeracaoRepasse(prestadorRecebimentoId)
    if (request.success) {
      this.context.commit('setHistoricoGeracaoRepasse', request.data)
      this.context.commit('setShowModalHistoricoGeracaoRepasse', true)
    }
    return request
  }

  @Action
  async getHistoricoIntegracaoRepasse(item: any) {
    const request = await this.remuneracaoMedica.getHistoricoIntegracaoRepasse(item)
    if (request.success) {
      this.context.commit('setHistoricoIntegracaoRepasse', request.data.itens)
      this.context.commit('setShowHistoricoIntegracaoTab', true)
    }
    return request
  }

  @Action
  async getValidacaoResultado(params: any) {
    const request = await this.remuneracaoMedica.getValidacaoResultado(params)
    if (request.success) {
      this.context.commit('setValidacaoResultado', request.data)
    }
    return request
  }

  @Action
  async getHistoricoCadastroAluguel(id: string) {
    const params: any = {
      id,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }
    const request = await this.remuneracaoMedica.getHistoricoCadastroAluguel(params)
    if (request.success) {
      this.context.commit('setHistoricoCadastroAluguel', request.data.itens)
      this.context.commit('setTotalItems', request.data.totalRegistros)
      this.context.commit('setShowModalCadastroAluguel', true)
    }
    return request
  }

  @Action
  async getHistoricoGeracaoItens(id: string) {
    const params: any = {
      medicoProducaoProcedimentoId: id,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }
    const request = await this.remuneracaoMedica.getHistoricoGeracaoItens(params)
    if (request.success) {
      this.context.commit('setHistoricoGeracaoItens', request.data.itens)
      this.context.commit('setTotalItems', request.data.totalRegistros)
      this.context.commit('setShowModalHistoricoGeracaoItens', true)
    }
    return request
  }

  @Action
  async getHistoricoPontuacao(prestadorRecebimentoId: string) {
    const params: any = {
      id: prestadorRecebimentoId,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }
    const request = await this.remuneracaoMedica.getHistoricoPontuacaoProfissional(params)
    if (request.success) {
      this.context.commit('setHistoricoPontuacao', request.data.itens)
      this.context.commit('setTotalItems', request.data.totalRegistros)
      this.context.commit('setShowModalHistoricoPontuacao', true)
    }
    return request
  }

  @Action
  async getHistoricoSenioridade(prestadorRecebimentoId: string) {
    const params: any = {
      id: prestadorRecebimentoId,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
    }
    const request = await this.remuneracaoMedica.getHistoricoPontuacao(params)
    if (request.success) {
      this.context.commit('setHistoricoSenioridade', request.data.itens)
      this.context.commit('setTotalItems', request.data.totalRegistros)
      this.context.commit('setShowModalHistoricoSenioridade', true)
    }
    return request
  }

  @Mutation
  setShowModalHistoricoSituacao(value: boolean) {
    this.modal.historicoSituacao = value
  }

  @Mutation
  setShowModalHistoricoGeracaoRepasse(value: boolean) {
    this.modalHistoricoGeracaoRepasse.historicoGeracaoRepasse = value
  }

  @Mutation
  setShowHistoricoIntegracaoTab(value: boolean) {
    this.showHistoricoIntegracaoTab = value
  }

  @Mutation
  setShowModalCadastroAluguel(value: boolean) {
    this.modalCadastroAluguel.historicoCadastroAluguel = value
  }

  @Mutation
  setShowModalHistoricoGeracaoItens(value: boolean) {
    this.modalHistoricoGeracaoItens.historicoGeracaoItens = value
  }

  @Mutation
  setIdForLoadItems(value: string) {
    this.idForLoadItems = value
  }

  @Mutation
  setShowModalHistoricoPontuacao(value: boolean) {
    this.modalPontuacao.historicoPontuacao = value
  }

  @Mutation
  setShowModalHistoricoSenioridade(value: boolean) {
    this.modalSenioridade.historicoSenioridade = value
  }

  @Mutation
  setHistoricoSituacao(value: Historico[]) {
    this.historicoSituacao = value
  }

  @Mutation
  setHistoricoGeracaoRepasse(value: any[]) {
    this.historicoGeracaoRepasse = value
  }

  @Mutation
  setHistoricoIntegracaoRepasse(value: any[]) {
    this.historicoIntegracaoRepasse = value
  }

  @Mutation
  setValidacaoResultado(value: any[]) {
    this.validacaoResultado = value
  }

  @Mutation
  setHistoricoCadastroAluguel(value: any[]) {
    this.historicoCadastroAluguel = value
  }

  @Mutation
  setHistoricoGeracaoItens(value: any[]) {
    this.historicoGeracaoItens = value
  }

  @Mutation
  setHistoricoPontuacao(value: any[]) {
    this.historicoPontuacao = value
  }

  @Mutation
  setHistoricoSenioridade(value: any[]) {
    this.historicoSenioridade = value
  }

  @Mutation
  setTotalItems(value: number) {
    this.totalItems = value
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  clearhistoricoSituacao() {
    this.historicoSituacao = []
  }

  @Mutation
  clearHistoricoCadastroAluguel() {
    this.historicoCadastroAluguel = []
  }

  @Mutation
  clearHistoricoGeracaoItens() {
    this.historicoGeracaoItens = []
  }
}
